import { PlanDuration } from '@hellodarwin/core/lib/features/entities/checkout-entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Spin from 'antd/es/spin';
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../features/providers/user-provider';
import { useCreateHandleCheckout } from '../../hooks/use-create-handle-checkout';

// The Auth0 redirect flow already preserves the full URL via
// use-handle-login.tsx's redirectUrl mechanism.
const PromoCheckoutRedirectPage: React.FC = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { isLoggedIn, profile } = useUser();
  const handleCheckout = useCreateHandleCheckout();
  const checkoutStarted = useRef(false);
  const { t } = useTranslations();

  useEffect(() => {
    if (!isLoggedIn || checkoutStarted.current) return;

    // Already paying → dashboard
    if (
      profile?.access_type === 'premium' ||
      profile?.access_type === 'expert' ||
      profile?.access_type === 'custom'
    ) {
      navigate('/dashboard', { replace: true });
      return;
    }

    const params = new URLSearchParams(search);
    const interval = (params.get('interval') as PlanDuration) || 'yearly';
    const coupon = params.get('coupon') || undefined;
    const freeTrial = params.get('ft') === 'true' || undefined;
    const closerOwnerId = params.get('closer_owner_id') || undefined;
    const locale = params.get('locale') || undefined;

    checkoutStarted.current = true;

    // Stripe success/cancel URLs point to /dashboard so the user never
    // returns to this page after payment or pressing Stripe's back button.
    const dashboardReturnUrl = `${window.location.origin}/dashboard`;

    void handleCheckout(
      interval,
      coupon,
      dashboardReturnUrl,
      freeTrial,
      closerOwnerId,
      locale,
    )
      .then((result) => {
        if (result) {
          return;
        }

        window.location.href = dashboardReturnUrl;
      })
      .catch((err) => {
        console.error('Failed to initiate promo checkout:', err);
        window.location.href = dashboardReturnUrl;
      });
  }, [isLoggedIn, profile?.access_type, search, handleCheckout, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '20px',
      }}
    >
      <Spin size="large" />
      <h2>{t('onboardingClient|promo_checkout_redirecting')}</h2>
      <p>{t('onboardingClient|promo_checkout_preparing_session')}</p>
    </div>
  );
};

export default PromoCheckoutRedirectPage;
